module.exports = "<div id=\"additional_information_1\" class=\"checkout-overview\">\n  <read-more class=\"checkout-overview__desc p-0 col-12\" [text]=\"info.detail.resortDescription\" [maxLength]=\"500\">\n  </read-more>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/resort-information/resort-information.component.html
// module id = ../../../../../src/app/check-out/resort-information/resort-information.component.html
// module chunks = main